import React from 'react';

import Icon from '../buttons/Icon';


const InfosMessage = (props) => {
   /*function sendDataToGTM(){
     //event label remonte les données renseignées lors de Click sur CTA "afficher plus de garages à proximité"
          window.dataLayer.push({
           'pageName':"multicréneaux",  
           'event': 'uaevent',  
           'eventCategory': 'Content',  
           'eventAction': "Display::MoreDealers",
           'eventLabel': window.labels['Multi-creneaux_AfficherPlusGarages'] 
          }); 
    props.onClick();
   }*/
   return (
      <div className="info-warning" onClick={() => props.onClick}>
         <Icon Name="warning" />
         <span tabIndex="0">{props.children}</span>
      </div>
   )
}

export default InfosMessage;
